function Fakie() {
  return (
    <div className="dice-face face--fakie">
      <span>FAKIE</span>
    </div>
  );
}

export default Fakie;
